/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserTypeDictionaryDto = {
    key?: UserTypeDictionaryDto.key;
    displayValue?: string;
};
export namespace UserTypeDictionaryDto {
    export enum key {
        SPORTS_CLUB = 'SPORTS_CLUB',
        COACH = 'COACH',
        PLAYER = 'PLAYER',
    }
}

